<div class="navbar-wrapper">
  <nav class="navbar bg-white navbar-grid">
      <div class="navbar-left d-flex align-items-center">
          <a class="navbar-brand text-s">
            <span class="fw-normal text-xs">Dashboard</span>/<span class="fw-bold text-xs">Admin</span>
          </a>
        </div>
      <div class="navbar-right d-flex align-items-center justify-content-end">
        <span class="user-icon rounded-circle bg-green secondary-text-dark d-flex justify-content-center align-items-center fw-bold custom-size">
          {{ getInitial(user_info.first_name) }}
        </span>
        <span class="user-name text-xs ms-2 me-3"
        >{{ user_info.first_name }} {{ user_info.last_name }}</span>
      </div>
    </nav>
</div>